export default __webpack_public_path__ + "static/media/logo.29a4e2d6.png";